// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__6Y_gY","obliqueLineWrap":"membershipbadge_obliqueLineWrap__ELfCo","obliqueLine":"membershipbadge_obliqueLine__1Z0pf"};